import { ReactNode } from "react"
import { LoginShowcase } from "@/components/auth/LoginShowcase"

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="light-surface flex h-svh overflow-hidden bg-[#f6f4ef] text-[#292d32]">
      <div className="flex min-w-0 flex-1 overflow-y-auto px-4 sm:px-8">
        <div className="m-auto flex w-full justify-center py-10">
          {children}
        </div>
      </div>
      <LoginShowcase />
    </div>
  )
}
